import { PersonResponseSchema } from "@/services";
import { z } from "zod";
import { UsersField } from "./types";
import { useCheckIfPersonnelsStepExist } from "@/hooks/use-check-if-personnels-step-exist";

export const UsersSchema = (subStep: string) => {
  const isPersonelStepExist = useCheckIfPersonnelsStepExist();

  if (!isPersonelStepExist || subStep === "a") {
    return z.object({}).optional();
  }

  return z
    .object({
      [UsersField.Users]: z.array(PersonResponseSchema).optional(),
      [UsersField.UsersAccurancy]: z.boolean(),
    })
    .refine(data => data.UsersAccurancy === true, {
      message: "UsersAccurancy must be true",
      path: ["UsersAccurancy"],
    });
};
